var _circle, _g, _g2, _circle2, _g3, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressChangeAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 138,
    viewBox: "0 0 138 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73.8397,
    cy: 73.9884,
    r: 63.3713,
    fill: "#E6F6FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1589_142)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33.2089,
    cy: 24.0765,
    r: 16.0765,
    fill: "#67D995"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1589_142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7637 23.7215H23.623C23.623 21.1371 24.6254 18.7073 26.4447 16.8803C28.2654 15.0533 30.6835 14.0468 33.2571 14.0468C35.8306 14.0468 38.2501 15.0533 40.0694 16.8803L39.2625 17.6907C37.6584 16.0799 35.5255 15.1922 33.2571 15.1922C30.9886 15.1922 28.8557 16.0799 27.2517 17.6907C25.6477 19.3015 24.7637 21.4435 24.7637 23.7215Z",
    fill: "#185230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2571 33.3963C30.6836 33.3963 28.264 32.3898 26.4447 30.5628L27.2517 29.7524C28.8557 31.3632 30.9887 32.2509 33.2571 32.2509C35.5255 32.2509 37.6585 31.3632 39.2625 29.7524C40.8665 28.1416 41.7505 25.9996 41.7505 23.7216H42.8911C42.8911 26.306 41.8888 28.7358 40.0695 30.5628C38.2502 32.3898 35.8306 33.3963 33.2571 33.3963Z",
    fill: "#185230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.545 26.7642L42.3208 24.5305L40.0965 26.7642L39.2896 25.9538L41.9173 23.3149C42.1397 23.0916 42.5018 23.0916 42.7243 23.3149L45.352 25.9538L44.545 26.7642Z",
    fill: "#185230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1934 24.2943C24.0422 24.2943 23.8968 24.2342 23.7899 24.1268L21.1636 21.4879L21.9706 20.6775L24.1948 22.9112L26.419 20.6775L27.226 21.4879L24.5983 24.1268C24.4914 24.2342 24.3459 24.2943 24.1948 24.2943H24.1934Z",
    fill: "#185230"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1589_142",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 128,
    height: 128
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.8397,
    cy: 73.9884,
    r: 63.3713,
    fill: "#E6F6FA"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1589_142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.631 58.7569L88.794 12.7856L144.957 58.7569V115.57H32.631V58.7569Z",
    fill: "#00A6CA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M88.794 15.2944L32.631 61.2657V58.4942L88.794 12.4987L144.957 58.2851V61.2657L88.794 15.2944Z",
    fill: "#005F8D"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 22.0182,
    height: 2.00165,
    transform: "matrix(1 0 0 -1 86.4229 102.937)",
    fill: "#005F8D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.4169,
    height: 29.2241,
    transform: "matrix(1 0 0 -1 87.2224 100.053)",
    fill: "#99DBEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.4249,
    y: 72.0302,
    width: 18.0149,
    height: 13.2109,
    fill: "#005F8D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.4249,
    y: 86.4422,
    width: 18.0149,
    height: 12.8106,
    fill: "#005F8D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.0182,
    height: 2.00165,
    transform: "matrix(1 0 0 -1 86.4229 102.055)",
    fill: "#99DBEA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 22.0182,
    height: 2.00165,
    transform: "matrix(1 0 0 -1 113.602 102.937)",
    fill: "#005F8D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.4169,
    height: 29.2241,
    transform: "matrix(1 0 0 -1 114.401 100.053)",
    fill: "#99DBEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.604,
    y: 72.0302,
    width: 18.0149,
    height: 13.2109,
    fill: "#005F8D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.604,
    y: 86.4422,
    width: 18.0149,
    height: 12.8106,
    fill: "#005F8D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.0182,
    height: 2.00165,
    transform: "matrix(1 0 0 -1 113.602 102.055)",
    fill: "#99DBEA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.3345,
    height: 4.55376,
    transform: "matrix(1 0 0 -1 51.9667 111.017)",
    fill: "#99DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4976 106.463H77.7723V75.5988C77.7723 69.1717 72.5621 63.9614 66.1349 63.9614C59.7078 63.9614 54.4976 69.1716 54.4976 75.5988V106.463Z",
    fill: "#99DBEA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.3942,
    height: 4.55376,
    transform: "matrix(1 0 0 -1 49.4359 115.571)",
    fill: "#CCEDF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0117 106.463H76.2506V75.5988C76.2506 70.01 71.72 65.4793 66.1311 65.4793C60.5423 65.4793 56.0117 70.01 56.0117 75.5988V106.463Z",
    fill: "#005F8D"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 89.8455,
    cy: 38.7604,
    r: 9.9749,
    fill: "#005F8D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.0082,
    cy: 37.506,
    r: 9.9749,
    fill: "#99DBEA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.0103,
    cy: 37.5061,
    r: 8.67383,
    fill: "#005F8D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.902,
    y: 37.0723,
    width: 17.7813,
    height: 0.867383,
    fill: "#99DBEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4431,
    y: 28.3985,
    width: 17.7813,
    height: 0.867383,
    transform: "rotate(90 89.4431 28.3985)",
    fill: "#99DBEA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.5037,
    cy: 88.2478,
    r: 0.867383,
    fill: "#004364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.162 59.304L88.7946 10.6171L148.427 59.304",
    stroke: "#005F8D",
    strokeWidth: 3.73872
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.162 59.304L88.7946 10.6171L118.611 34.9605",
    stroke: "#005F8D",
    strokeWidth: 3.73872
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8152 113.545C19.8152 118.976 15.3794 118.663 9.90761 118.663C4.43579 118.663 0 118.976 0 113.545C0 108.114 4.43579 103.711 9.90761 103.711C15.3794 103.711 19.8152 108.114 19.8152 113.545Z",
    fill: "#1D653B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.734 110.815C46.734 120.932 38.532 120.349 28.4143 120.349C18.2966 120.349 10.0945 120.932 10.0945 110.815C10.0945 100.697 18.2966 92.4951 28.4143 92.4951C38.532 92.4951 46.734 100.697 46.734 110.815Z",
    fill: "#67D995"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1589_142",
    x: 9.65501,
    y: 0.522562,
    width: 47.1078,
    height: 47.1079,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.73872
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1589_142"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1589_142",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1589_142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.187,
    height: 19.3496,
    fill: "white",
    transform: "translate(21.1636 14.0468)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressChangeAlert);
export default __webpack_public_path__ + "static/media/address_change_alert.e7fc19525063ada20428cf54a6c5438e.svg";
export { ForwardRef as ReactComponent };